module.exports = __webpack_public_path__ + "img/logo-title.1c23137c.svg";